import { VStack, ComponentWithAs, Heading, Icon, IconProps, Text } from "@chakra-ui/react";

function MarketingBox({
  color,
  icon,
  heading,
  description,
}: {
  color: string;
  icon: ComponentWithAs<"svg", IconProps>;
  heading: string;
  description: string;
}) {
  return (
    <VStack alignItems="start" rowGap={4} textColor={color}>
      <Icon as={icon} h={8} w="auto" />
      <Heading color={color} lineHeight="sm" size="sm">
        {heading}
      </Heading>
      <Text fontWeight="normal">{description}</Text>
    </VStack>
  );
}

export default MarketingBox;
